import { YUP_VALIDATIONS } from '@plug/helpers/yup-helpers';
import * as Yup from 'yup';

export const OrganizationInviteTeammatesSchema = Yup.object().shape({
  email: YUP_VALIDATIONS.email,
});
